import { useInfiniteQuery } from '@tanstack/react-query';
import { get_automation_versions_url } from '@/utils/urls';
import { AUTOMATION_VERSIONS_KEY } from '@/utils/queryKeys.ts';
import useAutomationId from '@/hooks/useAutomationId.ts';
import { useApiClient } from '@/context/ApiClientContext/useApiClient.ts';
import { AutomationVersionsSimple } from '@/types/automations.ts';

const useRetrieveAutomationVersions = (published: boolean = false, requestedAutomationId?: string) => {
  const apiClient = useApiClient();
  const routeAutomationId = useAutomationId();
  const automationId = requestedAutomationId ?? routeAutomationId;

  return useInfiniteQuery<AutomationVersionsSimple, Error>({
    queryKey: [...AUTOMATION_VERSIONS_KEY(automationId), published ? 'published' : 'unpublished'],
    queryFn: async ({ pageParam = 1 }) => {
      const response = await apiClient.get(get_automation_versions_url(automationId), {
        params: { page: pageParam, published },
      });
      return response.data;
    },
    getNextPageParam: (lastPage) => lastPage?.next?.page ?? undefined,
    initialPageParam: 1,
    enabled: !!automationId,
  });
};

export default useRetrieveAutomationVersions;
